export const TASK_DETAILS = 'TaskDetails'
export const TASKS_HOME = 'TasksHome'
